import React, {useEffect, useState} from 'react';
import {Button, Checkbox, ControlLabel, FormControl, FormGroup} from 'react-bootstrap';
import {widgetRegistrationSave} from '../../../../../../api/cp';

const RegistrationCustomText = ({
    eventWidget,
    title,
    name,
    property,
    row = 4,
    isCustomTextHidden = false,
    onUpdate,
    onUpdateSetting,
    defaultValue = '',
}) => {
    const PROPERTY_RU = `${property}Ru`;
    const PROPERTY_EN = `${property}En`;
    const [saving, setSaving] = useState(false);
    const [customText, setCustomText] = useState({
        [PROPERTY_RU]: '',
        [PROPERTY_EN]: '',
    });

    useEffect(() => {
        setCustomText({
            [PROPERTY_RU]: eventWidget[PROPERTY_RU] || defaultValue,
            [PROPERTY_EN]: eventWidget[PROPERTY_EN],
        })
    }, [eventWidget]);

    const handleSave = async () => {
        try {
            setSaving(true);
            await widgetRegistrationSave(eventWidget.eventId, customText);
            setSaving(false);

            onUpdateSetting(true);

            const timer = setTimeout(() => { 
                onUpdateSetting(false);
                clearTimeout(timer);
            }, 0);
        } catch (error) {
            console.error(error);
            setSaving(false);
        }
    }

    return (
        <FormGroup>
            <ControlLabel>
                {title}
            </ControlLabel>
            <FormGroup>
                <p>На русском языке:</p>
                <FormControl
                    defaultValue={customText[PROPERTY_RU] || ''}
                    componentClass="textarea" 
                    rows={row}
                    disabled={saving}
                    onChange={(e) => setCustomText({...customText, [PROPERTY_RU]: e.target.value})}
                />
            </FormGroup>
            <FormGroup>
                <p>На английском языке:</p>
                <FormControl
                    defaultValue={customText[PROPERTY_EN] || ''}
                    componentClass="textarea"
                    rows={row}
                    disabled={saving}
                    onChange={(e) => setCustomText({...customText, [PROPERTY_EN]: e.target.value})}
                />
            </FormGroup>
            <Button onClick={handleSave}>
                Сохранить
            </Button>
            <Checkbox
                checked={isCustomTextHidden}
                value={isCustomTextHidden}
                name={name}
                onChange={(e) => onUpdate(name, e.target.checked)}
            >
                Скрыть текст
            </Checkbox>
        </FormGroup>
    )
}

export default RegistrationCustomText;
